module.exports = __webpack_public_path__ + "media/images/tables/no_seats-37cbd40ef3f38913364ad882d752ff4b.png";